"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mappingProcessor_1 = require("./mapping/mappingProcessor");
Object.defineProperty(exports, "MappingProcessor", { enumerable: true, get: function () { return mappingProcessor_1.MappingProcessor; } });
var metaProcessor_1 = require("./meta/metaProcessor");
Object.defineProperty(exports, "MetaProcessor", { enumerable: true, get: function () { return metaProcessor_1.MetaProcessor; } });
var schemaProcessor_1 = require("./schema/schemaProcessor");
Object.defineProperty(exports, "SchemaProcessor", { enumerable: true, get: function () { return schemaProcessor_1.SchemaProcessor; } });
//# sourceMappingURL=index.js.map